import React, { useState } from "react";
import { FiFilter } from "react-icons/fi";
import DateFilter from "../../models/DateFilter";
import moment from "moment-timezone";
import NoDataFound from "../../common/NoDataFound";

export default function ContestwiseEarn({
  data,
  setStartDate,
  setEndDate,
  handleDateSubmit,
  startDate,
  endDate,
  setToggle,
  toggle,
}) {
  const [savedStartDate, setSavedStartDate] = useState("");
  const [savedEndDate, setSavedEndDate] = useState("");
  const handleSaveDate = () => {
    setSavedStartDate(startDate);
    setSavedEndDate(endDate);
    if (handleDateSubmit) {
      handleDateSubmit();
    }
  };
  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
    setSavedStartDate("");
    setSavedEndDate("");
    if (handleDateSubmit) {
      handleDateSubmit();
    }
  };
  return (
    <>
      <section className="shadow-md space-y-4">
        <div className="flex items-end justify-end md:flex-row flex-col-reverse gap-3">
          {savedStartDate && savedEndDate && (
            <button
              onClick={handleClearDates}
              className="inline-flex items-center space-x-2 rounded-lg px-2 py-2 text-md text-center text-white bg-[#124699] hover:bg-opacity-90"
            >
              <p className="font-semibold">Clear</p>
            </button>
          )}
          <button
            onClick={() => setToggle(true)}
            className="inline-flex items-center space-x-2 rounded-lg px-2 py-2 text-md text-center text-white bg-[#124699] hover:bg-opacity-90"
          >
            <FiFilter className="font-bold text-white w-4 h-4" />
            <p className="font-semibold">Filter</p>
            {savedStartDate && savedEndDate && (
              <p>
                (
                {`${moment(savedStartDate).format("Do MMMM")} - ${moment(
                  savedEndDate
                ).format("Do MMMM")}`}
                )
              </p>
            )}
          </button>
        </div>

        <div className="bg-white overflow-auto rounded-xl px-0">
          <div className="relative shadow-md sm:rounded-lg">
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-[#e6eaed]">
                  <tr>
                    {["Contest Name", "Count", "Earning"].map(
                      (header, index) => (
                        <th
                          key={index}
                          scope="col"
                          className="cursor-pointer border-y border-slate-200 bg-slate-300 p-5 transition-colors"
                        >
                          {header}
                        </th>
                      )
                    )}
                  </tr>
                </thead>
                <tbody>
                  {data &&
                    data.contests?.length > 0 ?
                    data.contests.map((user, index) => {
                      const { contestName, users, totalFees } = user;
                      return (
                        <tr key={index} className="bg-white border-b !h-[50px]">
                          <td className="p-3 whitespace-nowrap">
                            {contestName}
                          </td>
                          <td className="p-3 whitespace-nowrap">{users}</td>
                          <td className="p-3 whitespace-nowrap">{totalFees}</td>
                        </tr>
                      );
                    }):
                    <tr>
                    <td
                      colSpan={3}   
                      className="p-5 text-center text-gray-500"
                    >
                      <NoDataFound />
                    </td>
                  </tr>
                    }
                </tbody>
              </table>
            </div>
          </div>
          {toggle && (
            <DateFilter
              setToggle={setToggle}
              toggle={toggle}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              handleDateSubmit={handleSaveDate}
              startDate={startDate}
              endDate={endDate}
              onClose={() => {
                setToggle(false);
                handleClearDates();
              }}
            />
          )}
        </div>
      </section>
    </>
  );
}
